import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useState, useCallback } from 'react';
import { input as input$1 } from '../Input/Input.tokens.js';
import { useAutoResize, mergeRefs } from '@equinor/eds-utils';
import { jsx } from 'react/jsx-runtime';
import { Input } from '../Input/Input.js';
import { useEds } from '../EdsProvider/eds.context.js';

var _excluded = ["variant", "disabled", "type", "rowsMax"];
var input = input$1;
var Textarea = /*#__PURE__*/forwardRef(function Textarea(_ref, ref) {
  var variant = _ref.variant,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    rowsMax = _ref.rowsMax,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    textareaEl = _useState2[0],
    setTextareaEl = _useState2[1];
  var _useEds = useEds(),
    density = _useEds.density;
  var spacings = density === 'compact' ? input.modes.compact.spacings : input.spacings;
  var lineHeight = input$1.typography.lineHeight;
  var top = spacings.top,
    bottom = spacings.bottom;
  var fontSize = 16;
  if (textareaEl) {
    fontSize = parseInt(window.getComputedStyle(textareaEl).fontSize);
  }
  var padding = parseInt(top) + parseInt(bottom);
  var maxHeight = parseFloat(lineHeight) * fontSize * rowsMax + padding;
  useAutoResize(textareaEl, rowsMax ? maxHeight : null);
  var combinedRef = useCallback(function () {
    return mergeRefs(ref, setTextareaEl);
  }, [setTextareaEl, ref])();
  var inputProps = _objectSpread({
    ref: combinedRef,
    type: type,
    disabled: disabled,
    variant: variant
  }, other);
  var adornmentsToTop = {
    style: {
      alignItems: 'flex-start'
    }
  };
  return /*#__PURE__*/jsx(Input, _objectSpread({
    as: "textarea",
    rightAdornmentsProps: adornmentsToTop,
    leftAdornmentsProps: adornmentsToTop,
    style: {
      height: 'auto'
    }
  }, inputProps));
});

export { Textarea };
